import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'

import Select, { components } from 'react-select';
import removeImg from './icons/remove.svg'
import moment from 'moment';
import { Modal, OverlayTrigger, Popover, Overlay } from "react-bootstrap";
import uuid from 'react-uuid';

import { Drawer, Button, Space } from 'antd';
import { ResponsiveBar } from '@nivo/bar';

import { DateRangePickerComponent} from '@syncfusion/ej2-react-calendars';
import './date-range.css'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';
import { isFunction } from 'formik';

function DealerCollectionSummary() {
    const [user, setUser] = useState({});
    const [organization_id, setOrganization_id] = useState("")
    const [organization_list, setorganization_list] = useState([]);
    // const timer = useRef(0)
    const timer = useRef(0)
    const [clock_timer, setClockTimer] = useState(0);
    const [state, setstate] = useState(2);
    const [state1, setstate1] = useState(2);

    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    const [state_org, setstate_org] = useState(2);
    const [organization_name, setOrganization_name] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    const [redirect_to_login, setRedirect_to_login] = useState(2);

    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))

    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("");
    const [Datearr, setDatearr] = useState([]);
    const daterange_picker_ref = useRef();
    //const [startDate, endDate] = dateRange;

    //const [startDate, setStartDate] = useState(moment.utc().subtract(6,"days").format("YYYY-MM-DD"))
    let [timezone_change,set_timezone_change] = useState("+00:00");
    const [Date_format, setDate_format] = useState("");

    const [DealerCollectionList, setDealerCollectionList] = useState([]);
    const [AllDealerCollectionList, setAllDealerCollectionList] = useState([]);

    const [AlldealerList, setAlldealerList] = useState([]);
    const [dealerList, setdealerList] = useState([]);

    const [AllBrandList, setAllBrandList] = useState([]);
    const [BrandList, setBrandList] = useState([]);

    const [CurrencyList, setCurrencyList] = useState([]);

    const [selectedDealer, setSelectedDealer] = useState(null);
    const [SelectedBrand, setSelectedBrand] = useState({label:"All",value:"All"});
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [CurrencySymbol, setCurrencySymbol] = useState("");

    const [navtype, setnavtype] = useState("Cheque");
    const [dso_navtype, setdso_navtype] = useState("Cheque");
    const [drawer_navtype, setdrawer_navtype] = useState("Overview");

    const [Dealer_name, setDealer_name] = useState("");
    const [Collection_details, setCollection_details] = useState(null);
    const [TotalCollection_details, setTotalCollection_details] = useState([]);
    const [DrawerCollection_details, setDrawerCollection_details] = useState(null);
    const [ChildDrawerCollection_details, setChildDrawerCollection_details] = useState(null);
    const [Payment_details, setPayment_details] = useState([]);
    const [Collection_history_details, setCollection_history_details] = useState([]);
    const [open, setOpen] = useState(false);
    const [Childopen, setChildopen] = useState(false);
    const [grandTotal, setGrandTotal] = useState(0)
    const [submitButton, SetSubmitButton] = useState(false);
    const [Colour_details, setColour_details] = useState(["hsl(272, 70%, 50%)","hsl(185, 70%, 50%)","hsl(121, 70%, 50%)"]);

    const [DealerApiState, setDealerApiState] = useState(false);
    const [DenominationModalShow, setDenominationModalShow] = useState(false)

    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);

    const [FinalamtArray, setFinalamtArray] = useState([]);
    const [amtArray, setamtArray] = useState([]);
    const [Graph_data1, setGraph_data1] = useState([]);
    const [Graph_data2, setGraph_data2] = useState([]);
    const [Graph_data3, setGraph_data3] = useState([]);
    const [Graph_data4, setGraph_data4] = useState([]);

    let [user_name, setuser_name] = useState("");
    let [user_type, setuser_type] = useState("");
    let [dealer_organization_id, setdealer_organization_id] = useState("");
    let [user_id, setuser_id] = useState("");


    const overlay_ref = useRef()

    const search_length = 2;

    const days_limit = 30;

    var page_name = "dealer-collection-summary";

    const readOnlyStyles = {
        backgroundColor: "lightgray",
        color: "gray",
        fontSize: "12px",
        border: "1px dotted gray",
        cursor: "text"
    }

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const setUpDrawer = (id) => {
        let tempData = TotalCollection_details.find(option => option.unique_id == id);
        //console.log(tempData)
        setOpen(true);
        setdrawer_navtype("Overview");
        setCollection_details(tempData);
        getCollectionHistoryDetails(id);
        
    }

    const onClose = () => {
        setOpen(false);
        setCollection_history_details([]);
        setChildDrawerCollection_details(null);
    };

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser(user_object)
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        setRedirect_to_login(1);
                    });

                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            setuser_name(res.data.user_type.name);
                            setuser_type(res.data.user_type.type);
                            setdealer_organization_id(res.data.user_type.organization_id);
                            setuser_id(res.data.user_type.id);
                            setSelectedDealer({label:res.data.user_type.name,value:res.data.user_type.id})
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (temp == 1) break;
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (component[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(component[j]["read"])
                                            setwrite(component[j]["write"])
                                            // setwrite(0)
                                            // break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }

                        }
                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            timer.current = process.env.REACT_APP_JWT_EXPIRY;
                        }
                        else {
                            timer.current = res.data.audience_count;
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            // console.log(timer)

            timer.current = timer.current - 1
            if (timer.current > 0 && timer.current < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                if (!clockTimerModalShow) {
                    setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                    setClockTimerModalShow(true)
                }
            }
        }, 1000);
        
        return () => {clearInterval(timer_interval_ref)};
    }, []);


useEffect(() => {
    if(Datearr.length>0 && TotalCollection_details.length>0 && Object.keys(selectedDealer).length>0 && Object.keys(selectedCurrency).length>0 && Object.keys(SelectedBrand).length>0)
    { 
        let arr=[...TotalCollection_details];
        arr = arr.filter(option => option.dealer_id===selectedDealer.value && option.currency.Currency_code===selectedCurrency.value);
        var check_first = First_graph_set_up(arr,SelectedBrand.value);
        var check_fourth = Second_graph_set_up(arr,SelectedBrand.value);
        setstate(1);
    }
}, [TotalCollection_details,selectedDealer,SelectedBrand,selectedCurrency,Datearr]);

    async function getUserRole() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-role`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            let user_details = body.data[0].user_details;
            //setUser_role(body.data[0].user_role);
            if (body.data[0].user_role === "DSO") {
                //setSelectedDsoUser({ label: user_details.name + " - " + user_details.user_id, value: user_details.user_id });
            }
        }
        else {
            throw "transaction series api list error"
        }
    }

    async function getbasecurrency() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setDate_format(body[0].date_format);
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email,"page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") 
        {
            if(body.data.length>0)
            {
                if(body.data[0].timezone_value != "" && body.data[0].timezone_value != null)
                {
                    let timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    setStartDate(moment().utcOffset(timezone).subtract(6,"days").format("YYYY-MM-DD"));
                    setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else
                {
                    setStartDate(moment.utc().subtract(6,"days").format("YYYY-MM-DD"));
                    setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else
            {
                setStartDate(moment.utc().subtract(6,"days").format("YYYY-MM-DD"));
                setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getCollectionHistoryDetails(id) {
        //setstate(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-dealer-collection-entry-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name,"id":id,"organization_id":organization_id,"dealer_organization_id": dealer_organization_id}), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setCollection_history_details(body.data);
        }
    }

    async function getCollectionEntry(start,end) {
        setstate(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-dealer-collection-summary`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name,"user_id":user_id,"flag":"collection_summary","start_date":start,"end_date":end,"organization_id":organization_id,"dealer_organization_id": dealer_organization_id}), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            let currency=[];
            let brand=[...BrandList];
            let dealer=[...dealerList];
            let arr=[];
            if(body.data.length>0)
		    {
                let arr = [];
                let currency = [];
                let brand = [];
                body.data.map((obj, index) => {
                    if(!currency.find(x=>x.value==obj.currency.Currency_code))
                    {
                        currency.push({value:obj.currency.Currency_code,label:obj.currency.Currency_code,Currency_symbol:obj.currency.Currency_symbol});
                    }
                    obj.brand.map((obj1,index) => {
                        if(!brand.find(x=>x.value==obj1))
                        {
                            brand.push({label:obj.brand_list.filter(option => option.brand_id ==obj1)[0].brand_name,value:obj1});
                        }
                    })
                    let temp = obj.payment_details.map(a => { return { ...a } });
                    temp.map((obj1, index1) => {
                        let temp1 = obj1.payment_info.map(a => { return { ...a } });
                        temp1.map((obj2, index2) => {
                            let new_obj = obj2;
                            new_obj.payment_mode = obj1.payment_method;
                            new_obj.branch_name = obj.branch_name;
                            new_obj.unique_id = obj.unique_id;
                            new_obj.Currency_symbol = obj.currency.Currency_symbol;
                            new_obj.collection_entry_flag = obj.collection_entry_flag;
                            new_obj.dso_name = obj.dso_name;
                            new_obj.market_name = obj.market_name;
                            new_obj.dealer_display_name = obj.dealer_display_name;
                            new_obj.log_date_time = obj.log_date_time;
                            new_obj.log_status = obj.log_status;
                            new_obj.dcr_number = obj.dcr_number !== undefined ? obj.dcr_number : obj.pdcr_number;
                            new_obj.dcr_date = obj.dcr_date !== undefined ? obj.dcr_date : obj.pdcr_date;
                            arr.push(obj2);
                        });
                    });
                });
                setDealerCollectionList(arr);
                setAllDealerCollectionList(arr);
                setBrandList(brand);
                setdealerList(dealer);
                setCurrencyList(currency);
                setSelectedCurrency(currency[0]);
                setCurrencySymbol(currency[0].Currency_symbol);
                setTotalCollection_details(body.data);
                setDatearr(getDates(start,end));
            }
            else
            {
                setstate(3);
                setBrandList([]);
                setdealerList([]);
                setCurrencyList([]);
                setSelectedCurrency("");
                setCurrencySymbol("");
                setTotalCollection_details([]);
            } 
        }
        else {
            throw "dealer collection api list error"
        }
    }

    const All_data_set_up = (data) => {
        let arr=[...Datearr];
        let arr1=[];
        //console.log(arr);
        arr.map((obj,index) => {
            let obj1={};
            if(data.filter(option => option.date===moment(obj).format('D MMM')).length>0)
            {
                obj1=data.filter(option => option.date===moment(obj).format('D MMM'))[0];
            }
            else
            {
                obj1.date=moment(obj).format('D MMM');
            }
            arr1.push(obj1);
        })
        return arr1;
    }

    const First_graph_set_up = (data,brand_value) => {
        let arr=[];
        for(let i=0;i<data.length;i++)
        {
            let date="";
            if(data[i].collection_entry_flag=="dealer-collection-entry")
            {
                date=moment(data[i].dcr_date).format('D MMM');
            }
            else
            {
                date=moment(data[i].pdcr_date).format('D MMM');
            }
            if(arr.find(x=>x.date==date))
            {
                let p=arr.find(x=>x.date==date);
                for(let j=0;j<data[i].payment_details.length;j++)
                {   
                    let payment_info=data[i].payment_details[j].payment_info;
                    let payment_mode=data[i].payment_details[j].payment_method;
                    //let amount=payment_info.reduce((p, o) => { return p + (Math.round(Number(o.amount) * 100) / 100) }, 0);
                    let amount=payment_info.reduce((p, o) => { 
                        if((brand_value!="All" && o.brand_id==brand_value)||(brand_value=="All"))
                        {
                            return p + (Math.round(Number(o.amount) * 100) / 100)
                        }
                        else
                        {
                            return p;
                        }
                    }, 0);  
                    if(data[i].collection_entry_flag=="dealer-collection-entry")
                    {
                        if(payment_mode=="Cash")
                        { 
                            p.Cash= p.Cash+amount;
                        }
                        if(payment_mode=="Cheque")
                        {
                            p.Cheque= p.Cheque+amount;
                        }
                        if(payment_mode=="Bank Transaction")
                        {
                            p.Bank= p.Bank+amount;
                        }
                    }
                    else
                    {
                        if(payment_mode=="Cheque")
                        {
                            console.log(p.PDC);
                            console.log(amount);
                            p.PDC= p.PDC+amount;
                        } 
                    }
                }
            }
            else
            {
                let obj={};
                obj.date=moment(date).format("D MMM");
                obj.Cash=0;
                obj.Cheque=0;
                obj.Bank=0;
                obj.PDC=0;

                for(let j=0;j<data[i].payment_details.length;j++)
                {   
                    let payment_info=data[i].payment_details[j].payment_info;
                    let payment_mode=data[i].payment_details[j].payment_method;
                    //let amount=payment_info.reduce((p, o) => { return p + (Math.round(Number(o.amount) * 100) / 100) }, 0);
                    let amount=payment_info.reduce((p, o) => { 
                        if((brand_value!="All" && o.brand_id==brand_value)||(brand_value=="All"))
                        {
                            return p + (Math.round(Number(o.amount) * 100) / 100)
                        }
                        else
                        {
                            return p;
                        }
                    }, 0);  
                    if(data[i].collection_entry_flag=="dealer-collection-entry")
                    {
                        if(payment_mode=="Cash")
                        { 
                            obj.Cash= amount;
                            obj.cashcolor= "hsl(154, 70%, 50%)";
                        }
                        if(payment_mode=="Cheque")
                        {
                            obj.Cheque= amount;
                            obj.Chequecolor= "hsl(224, 70%, 50%)";
                        }
                        if(payment_mode=="Bank Transaction")
                        {
                            obj.Bank= amount;
                            obj.Bankcolor= "hsl(302, 70%, 50%)"; 
                        }
                    }
                    else
                    {
                        if(payment_mode=="Cheque")
                        {
                            obj.PDC= amount;
                            obj.PDCcolor= "hsl(334, 70%, 50%)";
                        }
                    }
                }
                arr.push(obj)
            }
        }
        arr=All_data_set_up(arr);
        setGraph_data1(arr);
        return true;
    }

    const Second_graph_set_up = (data,brand_value) => {
        console.log(brand_value);
        let arr=[];
        for(let i=0;i<data.length;i++)
        {
            let date="";
            if(data[i].collection_entry_flag=="dealer-collection-entry")
            {
                date=moment(data[i].dcr_date).format('D MMM');
            }
            else
            {
                date=moment(data[i].pdcr_date).format('D MMM');
            }
            if(arr.find(x=>x.date==date))
            {
                let p=arr.find(x=>x.date==date);
                let amount=0;
                let count=0;
                let color=[...Colour_details];
                for(let j=0;j<data[i].payment_details.length;j++)
                {   
                    let payment_info=data[i].payment_details[j].payment_info;
                    for(let k=0; k<payment_info.length; k++)
                    {
                        let brand_flag=false;
                        if(brand_value!="All" && payment_info[k].brand_id==brand_value)
                        {
                            brand_flag=true;
                        }
                        else if(brand_value=="All")
                        {
                            brand_flag=true;
                        }
                        if(brand_flag==true)
                        {
                            if(!p.hasOwnProperty(payment_info[k].brand_id))
                            {  
                                p[payment_info[k].brand_id]=payment_info[k].brand_id;
                                p[payment_info[k].brand_name]=(Math.round(Number(payment_info[k].amount) * 100) / 100);
                                p[payment_info[k].brand_name+"color"]=color[count];
                                if((color.length)==count)
                                {
                                    count=0;
                                }
                                else
                                {
                                    count=count+1;
                                }  
                            }
                            else
                            {
                                p[payment_info[k].brand_name]=p[payment_info[k].brand_name]+(Math.round(Number(payment_info[k].amount) * 100) / 100);
                            } 
                        }
                    }
                }
                
            }
            else
            {
                let obj={};
                obj.date=date;
                let amount=0;
                let count=0;
                let color=[...Colour_details];
                for(let j=0;j<data[i].payment_details.length;j++)
                {   
                    let payment_info=data[i].payment_details[j].payment_info;
                    for(let k=0; k<payment_info.length; k++)
                    {
                        let brand_flag=false;
                        console.log(payment_info[k].brand_id);
                        if(brand_value!="All" && payment_info[k].brand_id==brand_value)
                        {
                            brand_flag=true;
                        }
                        else if(brand_value=="All")
                        {
                            brand_flag=true;
                        }
                        if(brand_flag==true)
                        {
                            if(!obj.hasOwnProperty(payment_info[k].brand_id))
                            {  
                                obj[payment_info[k].brand_id]=payment_info[k].brand_id;
                                obj[payment_info[k].brand_name]=(Math.round(Number(payment_info[k].amount) * 100) / 100);
                                obj[payment_info[k].brand_name+"color"]=color[count];
                                if((color.length)==count)
                                {
                                    count=0;
                                }
                                else
                                {
                                    count=count+1;
                                }  
                            }
                            else
                            {
                                obj[payment_info[k].brand_name]=obj[payment_info[k].brand_name]+(Math.round(Number(payment_info[k].amount) * 100) / 100);
                            }
                        }  
                    }
                    //amount=amount+payment_info.reduce((p, o) => { return p + (Math.round(Number(o.amount) * 100) / 100) }, 0);  
                }
                
                
                console.log(obj);
                arr.push(obj)
            }
        }
        arr=All_data_set_up(arr);
        setGraph_data4(arr);
        return true;
    }

    function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
            dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
            currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
    }

    useEffect(() => {

        if((startDate!="") && (endDate!=""))
        {
            getCollectionEntry(startDate,endDate);
        }

    }, [startDate,endDate])

    

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getbasecurrency();
            let p2 = getTimezoneInformation();
            Promise.all([p2])
            .then(async () => {
                //setstate(1)
                console.log("all apis done")
            })
            .catch((err) => {
                //setstate(3)
                console.log(err)
                swal("Oops!", err, "error")
            })
        }
    }, [user, visibility, read, write])


    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    const Set_Denomination = (val) => {
        setFinalamtArray(val);
        setDenominationModalShow(true);
    }

    const customStyles = {
        ///.....
        menuPortal: provided => ({ ...provided, zIndex: 9999 }),
        menu: provided => ({ ...provided, zIndex: 9999 }),
        userTheme:'dark' ? dropdownStyleDark : {}
        ///.....
      }

    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            {
                redirect_to_login == 0 ? null : (redirect_to_login == 1 ? <>
                    <Redirect to={{ pathname: "/login" }} />
                </> : null)
            }

            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Collection Summary</h1>
                        {(startDate!=="" && endDate!="")&&
                        <div className="d-flex align-items-center gap-5 mx-5 my-2">
                            <DateRangePickerComponent
                                ref={daterange_picker_ref}
                                allowEdit={false}
                                focus={(e)=>{
                                    //console.log(e);
                                    daterange_picker_ref.current.show()
                                }}
                                delayUpdate={true}
                                change={(e)=>{
                                    setStartDate(e.startDate);
                                    setEndDate(e.endDate);
                                }}
                                startDate={startDate}
                                endDate={endDate}
                                // max={endDate!="" && endDate}
                                // min={startDate!="" && startDate}
                            />
                        </div>}
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        {
                            state == 1 ?
                                <>
                                <div className="row mb-sm-5 gx-0 ">
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Dealer:</label>
                                        <input type="text" className="form-control mb-2" placeholder="" style={readOnlyStyles} value={selectedDealer.label}  readOnly />
                                    </div>
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Brand:</label>
                                        <Select
                                            options={[{label:"All",value:"All"},...BrandList]}
                                            onChange={(val) => { setSelectedBrand(val);}}
                                            value={SelectedBrand}
                                            placeholder="Select DSO..."
                                            styles={customStyles}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Currency:</label>
                                        <Select
                                            options={CurrencyList}
                                            onChange={(val) => { setSelectedCurrency(val);}}
                                            value={selectedCurrency}
                                            placeholder="Select Currency..."
                                            styles={customStyles}
                                            isDisabled={CurrencyList.length==1}
                                        />
                                    </div>
                                </div>
                                <div className="row gy-5 g-xl-10">
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-xl-8">
                                            <div className="card-body p-0">
                                                <div className="px-9 pt-7 card-rounded h-275px w-100 bg-primary">
                                                    <div className="d-flex flex-stack">
                                                        <h3 className="m-0 text-white fw-bold fs-3">Dealer Collection Summary</h3>
                                                    </div>
                                                    <div className="d-flex text-center flex-column text-white pt-8">
                                                        <span className="fw-semibold fs-7">You Balance</span>
                                                        <span className="fw-bold fs-2x pt-1">{CurrencySymbol} {DealerCollectionList.filter(x =>((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")).reduce((p, o) => { return p + o.amount }, 0)}</span>
                                                    </div>
                                                </div>
                                                <div className="bg-body shadow-sm card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1" style={{"margin-top":"-100px"}}>            
                                                    <div className="d-flex align-items-center mb-6"> 
                                                        <div className="symbol symbol-45px w-40px me-5">
                                                            <span className="symbol-label bg-lighten">                             
                                                                <span className="svg-icon svg-icon-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M18.4 5.59998C21.9 9.09998 21.9 14.8 18.4 18.3C14.9 21.8 9.2 21.8 5.7 18.3L18.4 5.59998Z" fill="currentColor"></path>
                                                                <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM19.9 11H13V8.8999C14.9 8.6999 16.7 8.00005 18.1 6.80005C19.1 8.00005 19.7 9.4 19.9 11ZM11 19.8999C9.7 19.6999 8.39999 19.2 7.39999 18.5C8.49999 17.7 9.7 17.2001 11 17.1001V19.8999ZM5.89999 6.90002C7.39999 8.10002 9.2 8.8 11 9V11.1001H4.10001C4.30001 9.4001 4.89999 8.00002 5.89999 6.90002ZM7.39999 5.5C8.49999 4.7 9.7 4.19998 11 4.09998V7C9.7 6.8 8.39999 6.3 7.39999 5.5ZM13 17.1001C14.3 17.3001 15.6 17.8 16.6 18.5C15.5 19.3 14.3 19.7999 13 19.8999V17.1001ZM13 4.09998C14.3 4.29998 15.6 4.8 16.6 5.5C15.5 6.3 14.3 6.80002 13 6.90002V4.09998ZM4.10001 13H11V15.1001C9.1 15.3001 7.29999 16 5.89999 17.2C4.89999 16 4.30001 14.6 4.10001 13ZM18.1 17.1001C16.6 15.9001 14.8 15.2 13 15V12.8999H19.9C19.7 14.5999 19.1 16.0001 18.1 17.1001Z" fill="currentColor"></path>
                                                                </svg>
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center flex-wrap w-100">
                                                            <div className="mb-1 pe-3 flex-grow-1">
                                                                <a href="#" className="fs-5 text-gray-800 text-hover-primary fw-bold">Cash</a>
                                                                {/* <div className="text-gray-400 fw-semibold fs-7">100 Regions</div> */}
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <div className="fw-bold fs-5 text-gray-800 pe-1">{CurrencySymbol} {DealerCollectionList.filter(x => x.payment_mode == "Cash" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")).reduce((p, o) => { return p + o.amount }, 0)}</div>                          
                                                            </div>
                                                        </div>               
                                                    </div>       
                                                    <div className="d-flex align-items-center mb-6">
                                                        <div className="symbol symbol-45px w-40px me-5">
                                                            <span className="symbol-label bg-lighten">                               
                                                                <span className="svg-icon svg-icon-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor"></rect>
                                                                <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor"></rect>
                                                                <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor"></rect>
                                                                <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor"></rect>
                                                                </svg>
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center flex-wrap w-100">
                                                            <div className="mb-1 pe-3 flex-grow-1">
                                                                <a href="#" className="fs-5 text-gray-800 text-hover-primary fw-bold">Cheque</a>
                                                                {/* <div className="text-gray-400 fw-semibold fs-7">Quarter 2/3</div> */}
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <div className="fw-bold fs-5 text-gray-800 pe-1">{CurrencySymbol} {DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-collection-entry" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All"))).reduce((p, o) => { return p + o.amount }, 0)}</div>                                                                      
                                                                </div>
                                                        </div>                  
                                                    </div>           
                                                    <div className="d-flex align-items-center mb-6">
                                                        <div className="symbol symbol-45px w-40px me-5">
                                                            <span className="symbol-label bg-lighten">                             
                                                            <span className="svg-icon svg-icon-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M15 19H7C5.9 19 5 18.1 5 17V7C5 5.9 5.9 5 7 5H15C16.1 5 17 5.9 17 7V17C17 18.1 16.1 19 15 19Z" fill="currentColor"></path>
                                                            <path d="M8.5 2H13.4C14 2 14.5 2.4 14.6 3L14.9 5H6.89999L7.2 3C7.4 2.4 7.9 2 8.5 2ZM7.3 21C7.4 21.6 7.9 22 8.5 22H13.4C14 22 14.5 21.6 14.6 21L14.9 19H6.89999L7.3 21ZM18.3 10.2C18.5 9.39995 18.5 8.49995 18.3 7.69995C18.2 7.29995 17.8 6.90002 17.3 6.90002H17V10.9H17.3C17.8 11 18.2 10.7 18.3 10.2Z" fill="currentColor"></path>
                                                            </svg>
                                                            </span>
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center flex-wrap w-100">
                                                            <div className="mb-1 pe-3 flex-grow-1">
                                                                <a href="#" className="fs-5 text-gray-800 text-hover-primary fw-bold">Bank</a>
                                                                {/* <div className="text-gray-400 fw-semibold fs-7">80% Rate</div> */}
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <div className="fw-bold fs-5 text-gray-800 pe-1">{CurrencySymbol} {DealerCollectionList.filter(x => x.payment_mode == "Bank Transaction" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")).reduce((p, o) => { return p + o.amount }, 0)}</div>                                
                                                                </div>
                                                            </div>                
                                                        </div>       
                                                        <div className="d-flex align-items-center ">
                                                            <div className="symbol symbol-45px w-40px me-5">
                                                                <span className="symbol-label bg-lighten">                             
                                                                    <span className="svg-icon svg-icon-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="currentColor"></path>
                                                                    <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor"></rect>
                                                                    <rect x="7" y="12" width="10" height="2" rx="1" fill="currentColor"></rect>
                                                                    <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor"></rect>
                                                                    <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"></path>
                                                                    </svg>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div className="d-flex align-items-center flex-wrap w-100">
                                                                <div className="mb-1 pe-3 flex-grow-1">
                                                                    <a href="#" className="fs-5 text-gray-800 text-hover-primary fw-bold">PDC</a>
                                                                    {/* <div className="text-gray-400 fw-semibold fs-7">3090 Refunds</div> */}
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="fw-bold fs-5 text-gray-800 pe-1">{CurrencySymbol} {DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-pdc-collection-entry" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All"))).reduce((p, o) => { return p + o.amount }, 0)}</div>                              

                                                                </div>
                                                                </div>                 
                                                        </div>
                                                    </div>   
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-8 mb-5 mb-xl-10">
                                            <div className="card card-flush h-xl-100">
                                                <div className="card-header pt-7">    
                                                    <h3 className="card-title align-items-start flex-column">			
                                                        <span className="card-label fw-bold text-gray-800">Collection details</span>
                                                    </h3>
                                                </div>

                                                <div className="card-body">                   
                                                    <ul className="nav nav-pills nav-pills-custom mb-3" role="tablist">        
                                                        <li className="nav-item mb-3 me-3 me-lg-6" role="presentation">
                                                            <a className={`nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2 
                                                                ${navtype === "Cheque" && "active"}`} onClick={(e) => { setnavtype("Cheque"); }}>
                                                                <div className="nav-icon mb-3">        
                                                                <i className="fa-solid fa-money-check fs-1 p-0"></i>                                                                                                                                                                     
                                                                </div>
                                                                <span className="nav-text text-gray-800 fw-bold fs-6 lh-1">
                                                                Cheque</span> 
                                                                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>   
                                                            </a>
                                                        </li>         
                                                        <li className="nav-item mb-3 me-3 me-lg-6" role="presentation"> 
                                                            <a className={`nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2 
                                                                ${navtype === "Bank Transaction" && "active"}`} onClick={(e) => { setnavtype("Bank Transaction"); }}>
                                                                
                                                                <div className="nav-icon mb-3">        
                                                                    <i className="fa-solid fa-building-columns fs-1 p-0"></i>                                                                                                                                                                     
                                                                </div>
                                                                <span className="nav-text text-gray-800 fw-bold fs-6 lh-1">
                                                                Bank</span> 
                                                                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                                            </a>   
                                                        </li>                       
                                                        <li className="nav-item mb-3 me-3 me-lg-6" role="presentation"> 
                                                            <a className={`nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2 
                                                                ${navtype === "Cash" && "active"}`} onClick={(e) => { setnavtype("Cash"); }}>
                                                                <div className="nav-icon mb-3">        
                                                                    <i className="fa-solid fa-money-bill-wave fs-1 p-0"></i>                                                                                                                                                                     
                                                                </div>
                                                                <span className="nav-text text-gray-800 fw-bold fs-6 lh-1">
                                                                    Cash</span> 
                                                                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item mb-3 me-3 me-lg-6" role="presentation"> 
                                                            <a className={`nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2 
                                                                ${navtype === "PDC" && "active"}`} onClick={(e) => { setnavtype("PDC"); }}>
                                                                <div className="nav-icon mb-3">        
                                                                    <i className="fa-solid fa-money-check fs-1 p-0"></i>                                                                                                                                                                     
                                                                </div>
                                                                <span className="nav-text text-gray-800 fw-bold fs-6 lh-1">
                                                                PDC</span> 
                                                                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                                            </a>
                                                        </li>              
                                                    </ul>             
                                                    <div className="tab-content">
                                                        <div className="tab-pane fade active show">
                                                        {
                                                            ((navtype=="Cheque" ? DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-collection-entry" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All"))):
                                                            navtype=="Cash"? DealerCollectionList.filter(x => x.payment_mode == "Cash" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")):
                                                            navtype=="Bank Transaction"? DealerCollectionList.filter(x => x.payment_mode == "Bank Transaction" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")):
                                                            DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-pdc-collection-entry" && ((SelectedBrand.value!=="All" && x.brand_name==SelectedBrand.label) || SelectedBrand.value==="All")))).length > 0) ?
                                                            <>
                                                            <div className="table-responsive">
                                                                <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-130px">Id</th>
                                                                            <th className="min-w-130px">Type</th>
                                                                            <th className="min-w-120px">DCR Date</th>
                                                                            <th className="min-w-110px">Entry Date</th>
                                                                            <th className="min-w-140px">Brand</th>
                                                                            <th className="min-w-140px">Amount</th>
                                                                            <th className="min-w-100px text-end"></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {((navtype=="Cheque" ? DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-collection-entry")):
                                                                    navtype=="Cash"? DealerCollectionList.filter(x => x.payment_mode == "Cash"):
                                                                    navtype=="Bank Transaction"? DealerCollectionList.filter(x => x.payment_mode == "Bank Transaction"):
                                                                    DealerCollectionList.filter(x =>(x.payment_mode == "Cheque" && x.collection_entry_flag === "dealer-pdc-collection-entry")))).map((obj3, indx3) => {
                                                                        return (
                                                                            <>
                                                                            {((SelectedBrand.value!=="All" && SelectedBrand.label===obj3.brand_name)|| SelectedBrand.value==="All")&&
                                                                            <tr>
                                                                                <td>
                                                                                    <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.dcr_number != undefined ? <>{obj3.dcr_number}</> : <>{obj3.pdcr_number}</>}</a>
                                                                                    <span className="text-muted fw-semibold text-muted d-block fs-7">Branch: {obj3.branch_name}</span>
                                                                                </td>
                                                                                <td>
                                                                                {obj3.dcr_number!=undefined?
                                                                                    <span className="badge badge-light-info">DCR</span>
                                                                                    :
                                                                                    <span className="badge badge-light-info">PDCR</span>
                                                                                }  
                                                                                </td>
                                                                                <td>{obj3.dcr_date != undefined ? <>{moment(obj3.dcr_date).format(Date_format)}</> : <>{moment(obj3.pdcr_date).format(Date_format)}</>}</td>
                                                                                <td>{moment(obj3.log_date_time).format(Date_format)}</td>
                                                                                <td>
                                                                                    {obj3.brand_name}
                                                                                </td>
                                                                                <td>{CurrencySymbol} {obj3.amount}</td>
                                                                                <td className="text-end">
                                                                                    <a onClick={(e) => {setUpDrawer(obj3.unique_id);}} className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                                                                                        <span className="svg-icon svg-icon-5 svg-icon-gray-700"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z" fill="currentColor"></path>
                                                                                        <path opacity="0.3" d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                        </span>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>}    
                                                                            </>
                                                                        )})}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            </>
                                                            :
                                                            <>
                                                                <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6">
                                                                    <span className="svg-icon svg-icon-2tx svg-icon-warning me-4"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                                                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                                                                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                                                                    </svg>
                                                                    </span>
                                                                    <div className="d-flex flex-stack flex-grow-1 ">
                                                                        <div className=" fw-semibold">
                                                                            <h4 className="text-gray-900 fw-bold">No Data Available!</h4>
                                                                        </div>
                                                                    </div>
                                                                </div><br />
                                                            </>
                                                        }                                                                               
                                                        </div>
                                                    </div>       
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gy-5 g-xl-10">
                                        <div className="col-xl-12 mb-5 mb-xl-10">
                                            <div className="card card-flush h-xl-100">
                                                <div className="card-header pt-7">    
                                                    <h3 className="card-title align-items-start flex-column">			
                                                        <span className="card-label fw-bold text-gray-800">Date wise collection details</span>
                                                        
                                                        {/* <span className="text-gray-400 mt-1 fw-semibold fs-6">Total 424,567 deliveries</span> */}
                                                    </h3>
                                                    {/* <div className="card-toolbar">   
                                                        <a href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/add-product.html" className="btn btn-sm btn-light">Add Product</a>             
                                                    </div> */}
                                                </div>
                                                <div className="card-body">  
                                                    <div style={{overflowX: "auto" }}>
                                                        <div style={{ height: 500,minWidth:Graph_data1.length*100 }}>
                                                            <ResponsiveBar
                                                                data={Graph_data1}
                                                                keys={[
                                                                    'Cash',
                                                                    'Cheque',
                                                                    'Bank',
                                                                    'PDC'
                                                                ]}
                                                                indexBy="date"
                                                                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                                                                padding={0.3}
                                                                valueScale={{ type: 'linear' }}
                                                                indexScale={{ type: 'band', round: true }}
                                                                colors={{ scheme: 'nivo' }}
                                                                defs={[
                                                                    {
                                                                        id: 'dots',
                                                                        type: 'patternDots',
                                                                        background: 'inherit',
                                                                        color: '#38bcb2',
                                                                        size: 4,
                                                                        padding: 1,
                                                                        stagger: true
                                                                    },
                                                                    {
                                                                        id: 'lines',
                                                                        type: 'patternLines',
                                                                        background: 'inherit',
                                                                        color: '#eed312',
                                                                        rotation: -45,
                                                                        lineWidth: 6,
                                                                        spacing: 10
                                                                    }
                                                                ]}
                                                                fill={[
                                                                    {
                                                                        match: {
                                                                            id: 'Cash'
                                                                        },
                                                                        id: 'dots'
                                                                    },
                                                                    {
                                                                        match: {
                                                                            id: 'Bank'
                                                                        },
                                                                        id: 'lines'
                                                                    }
                                                                ]}
                                                                borderColor={{
                                                                    from: 'color',
                                                                    modifiers: [
                                                                        [
                                                                            'darker',
                                                                            1.6
                                                                        ]
                                                                    ]
                                                                }}
                                                                axisTop={null}
                                                                axisRight={null}
                                                                axisBottom={{
                                                                    tickSize: 1,
                                                                    tickPadding: 4,
                                                                    tickRotation: -45,
                                                                    legend: 'Date',
                                                                    legendPosition: 'middle',
                                                                    legendOffset: 40
                                                                }}
                                                                axisLeft={{
                                                                    tickSize: 1,
                                                                    tickPadding: 4,
                                                                    tickRotation: 0,
                                                                    legend: 'Payment Mode',
                                                                    legendPosition: 'middle',
                                                                    legendOffset: -40
                                                                }}
                                                                labelSkipWidth={12}
                                                                labelSkipHeight={12}
                                                                labelTextColor={{
                                                                    from: 'color',
                                                                    modifiers: [
                                                                        [
                                                                            'darker',
                                                                            1.6
                                                                        ]
                                                                    ]
                                                                }}
                                                                legends={[
                                                                    {
                                                                        dataFrom: 'keys',
                                                                        anchor: 'bottom-right',
                                                                        direction: 'column',
                                                                        justify: false,
                                                                        translateX: 120,
                                                                        translateY: 0,
                                                                        itemsSpacing: 2,
                                                                        itemWidth: 100,
                                                                        itemHeight: 20,
                                                                        itemDirection: 'left-to-right',
                                                                        itemOpacity: 0.85,
                                                                        symbolSize: 20,
                                                                        effects: [
                                                                            {
                                                                                on: 'hover',
                                                                                style: {
                                                                                    itemOpacity: 1
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                ]}
                                                                role="application"
                                                                ariaLabel="Nivo bar chart demo"
                                                                barAriaLabel={function(e){return e.id+": "+e.formattedValue+" in country: "+e.indexValue}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>  
                                            </div>  
                                        </div>  
                                    </div>
                                    <div className="row gy-5 g-xl-10">
                                        <div className="col-xl-12 mb-5 mb-xl-10">
                                            <div className="card card-flush h-xl-100">
                                                <div className="card-header pt-7">    
                                                    <h3 className="card-title align-items-start flex-column">			
                                                        <span className="card-label fw-bold text-gray-800">Brand wise collection details</span>
                                                        
                                                        {/* <span className="text-gray-400 mt-1 fw-semibold fs-6">Total 424,567 deliveries</span> */}
                                                    </h3>
                                                    {/* <div className="card-toolbar">   
                                                        <a href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/add-product.html" className="btn btn-sm btn-light">Add Product</a>             
                                                    </div> */}
                                                </div>
                                                <div className="card-body">  
                                                    <div style={{overflowX: "auto" }}>
                                                        <div style={{ height: 500,minWidth:Graph_data4.length*100 }}>
                                                            <ResponsiveBar
                                                                data={Graph_data4}
                                                                keys={BrandList.map(x => { 
                                                                    if(x.label!=='All')
                                                                    {
                                                                        return x.label 
                                                                    } 
                                                                 })}
                                                                indexBy="date"
                                                                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                                                                padding={0.3}
                                                                valueScale={{ type: 'linear' }}
                                                                indexScale={{ type: 'band', round: true }}
                                                                colors={{ scheme: 'nivo' }}
                                                                defs={[
                                                                    {
                                                                        id: 'dots',
                                                                        type: 'patternDots',
                                                                        background: 'inherit',
                                                                        color: '#38bcb2',
                                                                        size: 4,
                                                                        padding: 1,
                                                                        stagger: true
                                                                    },
                                                                    {
                                                                        id: 'lines',
                                                                        type: 'patternLines',
                                                                        background: 'inherit',
                                                                        color: '#eed312',
                                                                        rotation: -45,
                                                                        lineWidth: 6,
                                                                        spacing: 10
                                                                    }
                                                                ]}
                                                                borderColor={{
                                                                    from: 'color',
                                                                    modifiers: [
                                                                        [
                                                                            'darker',
                                                                            1.6
                                                                        ]
                                                                    ]
                                                                }}
                                                                axisTop={null}
                                                                axisRight={null}
                                                                axisBottom={{
                                                                    tickSize: 1,
                                                                    tickPadding: 4,
                                                                    tickRotation: -45,
                                                                    legend: 'Date',
                                                                    legendPosition: 'middle',
                                                                    legendOffset: 40
                                                                }}
                                                                axisLeft={{
                                                                    tickSize: 1,
                                                                    tickPadding: 4,
                                                                    tickRotation: 0,
                                                                    legend: 'Payment Mode',
                                                                    legendPosition: 'middle',
                                                                    legendOffset: -40
                                                                }}
                                                                labelSkipWidth={12}
                                                                labelSkipHeight={12}
                                                                labelTextColor={{
                                                                    from: 'color',
                                                                    modifiers: [
                                                                        [
                                                                            'darker',
                                                                            1.6
                                                                        ]
                                                                    ]
                                                                }}
                                                                legends={[
                                                                    {
                                                                        dataFrom: 'keys',
                                                                        anchor: 'bottom-right',
                                                                        direction: 'column',
                                                                        justify: false,
                                                                        translateX: 120,
                                                                        translateY: 0,
                                                                        itemsSpacing: 2,
                                                                        itemWidth: 100,
                                                                        itemHeight: 20,
                                                                        itemDirection: 'left-to-right',
                                                                        itemOpacity: 0.85,
                                                                        symbolSize: 20,
                                                                        effects: [
                                                                            {
                                                                                on: 'hover',
                                                                                style: {
                                                                                    itemOpacity: 1
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                ]}
                                                                role="application"
                                                                ariaLabel="Nivo bar chart demo"
                                                                barAriaLabel={function(e){return e.id+": "+e.formattedValue+" in country: "+e.indexValue}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>  
                                            </div>  
                                        </div>  
                                    </div>                              
                                </>
                                :
                                state == 2 ?
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    :
                                    <>
                                        <div className="flex-lg-row-fluid">
                                            <div className="card card-flush pt-3">

                                                <div className="card-body pt-0">
                                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                        <div className="d-flex flex-stack flex-grow-1">
                                                            <h4 className="text-gray-800">No Data Available.</h4>
                                                        </div>
                                                        {/* <a href="/dealer-collection-entry" className="btn btn-primary px-6 align-self-center text-nowrap" data-bs-toggle="modal" data-bs-target="#kt_modal_new_card"> 
                                                        Refresh</a> */}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

            <Modal show={DenominationModalShow} onHide={() => { setDenominationModalShow(false) }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Denominations</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setDenominationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container' style={{ overflowY: "scroll", height: "25rem" }}>
                        {FinalamtArray.length > 0 &&
                            <table className="table table-row-dashed align-middle gs-0 gy-4 my-0">
                                <thead>
                                    <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                                        <th className="p-0 pb-3 min-w-100px text-start">AMOUNT</th>
                                        <th className="pe-0 text-end min-w-100px">QTY</th>
                                        <th className="pe-0 text-end min-w-100px">TOTAL PRICE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {FinalamtArray.map((obj4, indx4) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>
                                                        <span className="text-gray-800 fw-bold d-block fs-6">{CurrencySymbol}  {obj4.category}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-gray-800 fw-bold d-block fs-6 ps-0 text-end">x{obj4.count}</span>
                                                    </td>
                                                    <td className="text-end pe-0">
                                                        <span className="text-gray-800 fw-bold d-block fs-6">{CurrencySymbol}  {obj4.amount}</span>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                    }
                                    <tr>
                                        <td colspan="2" className="text-end">
                                            Subtotal
                                        </td>
                                        <td className="text-end">
                                            {CurrencySymbol}  {Math.round(FinalamtArray.reduce((p, o) => { return p + (Math.round((o.amount) * 100) / 100) }, 0) * 100) / 100}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setDenominationModalShow(false); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"/><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"/></svg>
            </a>}
                extra={
                    <Space>
                         {/* <Button onClick={onClose} type="primary">Close</Button> */}
                        <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {(Collection_details != null && write) &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {/* {(User_role=="Admin" && (Collection_details.log_status!=="voucher_creation" || Collection_details.log_status!=="cancelled"))&&
                                    <li className="py-1"><a onClick={(e) => { updateStatus(Collection_details.unique_id);}} className={`dropdown-item`}>Cancel</a></li>} */}
                                    {Collection_details.log_status==="DRAFT" &&
                                        <>
                                        {Collection_details.collection_entry_flag==="dealer-collection-entry" ?
                                        <li className="py-1"><a href={`/edit-dealer-collection-entry/${Collection_details.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                        :
                                        <li className="py-1"><a href={`/edit-dealer-pdc-collection-entry/${Collection_details.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                        }
                                        </>
                                    }   
                                </ul>
                            }
                        </div>
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${drawer_navtype === "Overview" && "active"}`} onClick={(e) => { setdrawer_navtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${drawer_navtype === "Transactions" && "active"}`} onClick={(e) => { setdrawer_navtype("Transactions"); }}>Transaction</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${drawer_navtype === "History" && "active"}`} onClick={(e) => { setdrawer_navtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {drawer_navtype === "Overview" ?
                        <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Overview</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Collection_details != null &&
                                <div className="card-body p-9">
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Id</label>
                                        <div className="col-lg-8">
                                            <span className="fw-bold fs-6 text-gray-800">{Collection_details.dcr_number!=undefined?<>{Collection_details.dcr_number}</>:<>{Collection_details.pdcr_number}</>}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Type</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dcr_number!=undefined?
                                                <span className="badge badge-light-primary">DCR</span>
                                                :
                                                <span className="badge badge-light-primary">PDCR</span>
                                            }</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Payment Mode</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="badge badge-light-primary">{Collection_details.payment_mode}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Date</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dcr_date!=undefined?<>{moment(Collection_details.dcr_date).format("ll")}</>:<>{moment(Collection_details.pdcr_date).format("ll")}</>}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.branch_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Dealer Name</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dealer_display_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">DSO User</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dso_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Status
                                        </label>
                                        <div className="col-lg-8 d-flex align-items-center">
                                            {Collection_details.log_status==="PENDING_APPROVAL" ?
                                                <span className="badge badge-light-warning">Pending</span>
                                                :
                                                Collection_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Collection_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Collection_details.log_status==="cancelled" ?
                                                <span className="badge badge-danger">Cancelled</span>
                                                :
                                                <span className="badge badge-success">{Collection_details.log_status}</span>
                                            }  
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                        {Collection_details.billing_address!==null &&
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.billing_address.state && Collection_details.billing_address.state},${Collection_details.billing_address.city}, ${Collection_details.billing_address.pincode},${Collection_details.billing_address.country}`}</span>
                                        </div>}
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                        {Collection_details.shipping_address!==null &&
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.shipping_address.state!=undefined && Collection_details.shipping_address.state},${Collection_details.shipping_address.city}, ${Collection_details.shipping_address.pincode}, ${Collection_details.shipping_address.country}`}</span>
                                        </div>}
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Tax Detils</label>
                                        <div className="col-lg-8 fv-row">
                                        {Collection_details.gstin_details!=null &&<span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.gstin_details.GstIn},${Collection_details.gstin_details.gst_treatment}`}</span>}
                                    </div>
                                    </div>        
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Remarks</label>
                                        <div className="col-lg-8">
                                            <span className="fw-semibold fs-6 text-gray-800">{Collection_details.remarks}</span>
                                        </div>
                                    </div>  
                                </div>
                            }
                        </>
                        :
                        drawer_navtype === "Transactions" ?
                            <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Transaction Details</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Collection_details != undefined &&
                                <div className="card-body p-9">
                                    <div className="table-responsive">
                                        <table className="table align-middle">
                                            <tbody>
                                            {
                                                Collection_details.payment_details.map((obj3, indx3) => {
                                                    return (
                                                    obj3.payment_info.length>0 &&
                                                        <>                     
                                                        <tr>
                                                            <td className="bg-light rounded text-gray-600 fs-8 fw-bold px-3 py-2" colspan="4">
                                                            {obj3.payment_method}</td>
                                                        </tr>
                                                        {
                                                            obj3.payment_info.map((obj4, indx4) => {
                                                            return (
                                                                <>
                                                                {obj3.payment_method=="Cash" ?                           
                                                                <tr>
                                                                    {/* <td className="fs-6 fw-bold text-gray-800">
                                                                        {obj4.brand_name}</td> */}
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {Collection_details.brand_list.filter(option => option.brand_id ==obj4.brand_id)[0].brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">
                                                                            Amount:
                                                                            <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>                                                         
                                                                    </td>
                                                                    <td className="pe-0 text-end">
                                                                        <button onClick={() => { Set_Denomination(obj3.Denomination); }} className="btn btn-sm btn-light">
                                                                            Denomination
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                obj3.payment_method=="Cheque" ?  
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {obj4.brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Cheque no:
                                                                        <span className="text-gray-800"> {obj4.cheque_no}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Cheque Date:
                                                                        <span className="text-gray-800"> {moment(obj4.cheque_date).format("ll")}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Amount:
                                                                        <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>  
                                                                    </td>
                                                                </tr>
                                                                :
                                                                obj3.payment_method=="Bank Transaction" &&
                                                                <>  
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {obj4.brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Date:
                                                                        <span className="text-gray-800"> {moment(obj4.transaction_date).format("ll")}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">
                                                                        Transaction Id:
                                                                            <span className="text-gray-800"> {obj4.transaction_reference_id}</span>                                                         
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Bank:
                                                                        <span className="text-gray-800"> {obj4.bank_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Amount:
                                                                        <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>  
                                                                    </td>
                                                                </tr>
                                                                </>    
                                                                }
                                                                </>
                                                                )
                                                            })
                                                        }
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            }
                            </>
                            :
                            drawer_navtype === "History" &&
                            <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                {Collection_details != undefined &&
                                    <h3 className="fw-bold m-0">{Collection_details.dcr_number!=undefined?<>{Collection_details.dcr_number}</>:<>{Collection_details.pdcr_number}</>}</h3>
                                }
                                </div>
                            </div>
                            {Collection_details != undefined &&
                                <div className="card-body p-9">
                                    {Collection_history_details.length>0 && Collection_history_details.map((obj, index) => {
                                        return (
                                            <>
                                            <div className="m-0">
                                                <div className="d-flex align-items-sm-center mb-5">
                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                                        <div className="flex-grow-1 me-2">
                                                        {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span>:obj.operation === "cancelled" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span>:obj.operation === "voucher_creation" ?<><span className="badge badge-lg badge-success fw-bold my-2">Voucher Created</span><a href={`/dealer-master-voucher-summary/${obj.master_voucher_id}`} className="text-primary fw-bold me-1"> #{obj.master_voucher_name}</a></>:<span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                            {/* <span className="text-gray-800 fw-bold d-block fs-4">{obj.operation === "voucher_creation" &&<>#<a href="#" className="text-primary fw-bold me-1">#{OBJ.MASTER_VOUCHER_NAME}</a></>}</span> */}
                                                        </div>                     
                                                    </div>               
                                                </div>
                                                <div className="timeline">                                 
                                                    <div className="timeline-item align-items-center mb-7">
                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>   
                                                        </div>                                 
                                                    </div>
                                                    <div className="timeline-item align-items-center">
                                                        <div className="timeline-line w-40px"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                        </div>                                
                                                    </div>                                        
                                                </div>
                                            </div>
                                            {Collection_history_details.length>1 &&
                                                <div className="separator separator-dashed my-6"></div>
                                            }
                                            </>
                                        )
                                    })}
                                </div>
                            }
                        </>
                    }
                </div>
            </Drawer>

            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} timer_ref={timer} />
        </>
    );
}
export default DealerCollectionSummary;